import React from 'react';

import { primaryTheme } from '@repo/ui/components/Buttons';
import { H2, P1 } from '@repo/ui/components/Typography';
import PropTypes from 'prop-types';

import LinkButton from 'components/LinkButton/LinkButton';

import { Wrapper } from './styles';

const defaultText = `If you need assistance or have any questions, don't hesitate to contact us.<br />We'll get back within 24 hours.`;

/**
 * A Questions Panel that is usually placed at the end of the page, to direct
 * the user to the Contact Page
 */
const Questions = ({ text = defaultText, ...props }) => {
  return (
    <Wrapper hideBorder={props.hideBorder} marginTop={props.marginTop}>
      {props.title ? props.title : <H2 margin="0 0 24px 0">Questions?</H2>}
      <P1 dangerouslySetInnerHTML={{ __html: text }} margin="0 0 24px 0" />
      <LinkButton
        height="40px"
        href="/contact"
        label="Contact us"
        theme={primaryTheme}
        width="190px"
      />
    </Wrapper>
  );
};

Questions.propType = {
  /**
   * text displayed on the panel
   */
  text: PropTypes.string,
  /**
   * whether to show the top divider or not
   */
  hideBorder: PropTypes.bool,
};

export default Questions;
